import { Transition } from "../router/Transition";

import * as PIXI from 'pixi.js';

import '../css/transition/PageTransition.scss';
import { BlockAnimation } from './BlockAnimation';
import { LineAnimation } from './LineAnimation';

export default class PageTransition extends Transition
{
	pixi:PIXI.Application;
	canvas:HTMLCanvasElement;
	container:HTMLDivElement;

	lineAnimation = new LineAnimation();
	blockAnimation = new BlockAnimation();
	animations = [this.lineAnimation];
	index = 0;

	componentDidMount()
	{
		this.pixi = new PIXI.Application({transparent: true, view: this.canvas, antialias:true});

		this.pixi.stage.addChild(this.lineAnimation);
		this.pixi.stage.addChild(this.blockAnimation);

		this.pixi.resizeTo = window;
	}

	private _resize = () =>
	{
		this.pixi.resizeTo = window;
	}

	private _block()
	{
		// document.body.style['overflow'] = 'hidden';
		document.body.style['pointer-events'] = 'none';
	}

	private _unblock()
	{
		// document.body.style['overflow'] = '';
		document.body.style['pointer-events'] = '';
	}

	transitionIn()
	{
		this.animations[this.index % this.animations.length].transitionIn(this._inComplete);
	}

	inComplete()
	{
		this.container.style['display'] = 'none';
		this.index++;
		this._unblock();
		this.pixi.stop();
	}
	
	transitionOut()
	{
		this.container.style['display'] = 'block';
		this._block();
		this.animations[this.index % this.animations.length].transitionOut(this._outComplete);
		this.pixi.start();
	}
	render()
	{
		return (
			<div ref={r => this.container = r} className='page-transition'><canvas ref={r => this.canvas = r}></canvas></div>
		);
	}
}